import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import util from '../../../../util';

import Spinner from 'react-spinkit';
import Popup from '../../../../components/SimplePopup';

import styles from './styles.module.scss';

import ViewRenderer from './views';
import { commonImages, operatorImages } from '../../../../assets/images';
import strings from '../../../../globalization';
import PopupContainer from '../../../../components/PopupContainer';
import { API } from '../../../../requests';
import moment from 'moment';
import { connect } from 'react-redux';

const POPUP_CONSTANTS = {
  STANDARD: 'standard',
  SPINNER: 'spinner',
  ERROR: 'error',
  SIMPLE_POPUP: 'simple-popup',
  ADD_DAYS_POPUP: 'add-days-popup',
  PERMITS_POPUP: 'permits-popup',
};

class PersonView extends Component {
  constructor(props) {
    super(props);

    const reduxProps = this.props.reduxProps;
    console.log('reduxProps--> Request New Permit', reduxProps);
    const {
      login: { loginInfo },
    } = reduxProps;
    const { company, user } = loginInfo;

    this.state = {
      popup: null,
      passDate: '',
      success: false,
      serverTime: null,
      RFIDNumber: '',
      companyId: company?.id,
      personActivityList: [],
      startDate: moment().subtract(1, 'year'),
      startTime: moment().startOf('day'),
      endDate: moment().add(1, 'day'),
      endTime: moment().endOf('day'),
      dates: {
        start: moment().subtract(1, 'year').format('MM-DD-YYYY'),
        end: moment().add(1, 'day').format('MM-DD-YYYY'),
      },
      totalCount: 0,
      roleId: user?.roleId
    };
  }

  componentDidMount = () => {
    this.reset();
    // this.getData();
    //    this.getCreditsData();
    this.getServerTime();
  };

  getServerTime = () => {
    API.getServerTime()
      .then(res => {
        console.log('getServerTime res.data', res.data);
        const date = new Date(res.data.timestamp);
        const showPerviousDate = date.getHours() < 8;
        this.setState({
          serverTime: showPerviousDate
            ? moment(date).subtract(1, 'day').toDate()
            : date,
        });
      })
      .catch(error => console.log(error));
  };

  getPersonData = () => {
    const { RFIDNumber } = this.state;
    if (!RFIDNumber) {
      this.showErrorPopup('Please enter RFID Number');
      return;
    }
    this.showSpinner();
    this.setState({
      personData: null,
    });
    API.fetchPersonByRFID(RFIDNumber)
      .then(res => {
        console.log('res.data', res.data);
        this.setState({
          personData: res.data,
          popup: null,
        });
        this.getPersonLatestData();
      })
      .catch(error => {
        console.log('error', error);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;

        this.setState({
          popup: null,
          personData: null,
        });
        this.showErrorPopup(
          errorMsg ||
          'There was an error while fetching the person details, please try again after some time.',
        );

        console.log(errorMsg);
      });
  };

  getPersonLatestData = () => {
    const { RFIDNumber } = this.state;
    if (!RFIDNumber) {
      console.log('RFID Number not available for this person');
      //  this.showErrorPopup('RFID Number not ');
      return;
    }
    this.showSpinner();
    this.setState({
      personLatestActivity: null,
    });
    API.fetchPersonLatestActivity({ personRFID: RFIDNumber })
      .then(res => {
        console.log('res.data', res.data);
        this.setState({
          personLatestActivity: res.data,
          popup: null,
        });
      })
      .catch(error => {
        console.log('error', error);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;

        this.setState({
          popup: null,
          personLatestActivity: null,
        });
        this.showErrorPopup(
          errorMsg ||
          'There was an error while fetching the person latest activity details, please try again after some time.',
        );

        console.log(errorMsg);
      });
  };

  getPopupContent = () => {
    const { popup } = this.state;
    if (!popup) return;
    switch (popup.type) {
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('case not handled', popup.type);
        return null;
      }
    }
  };

  showConfirmationPopup = (message, onConfirm, data) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: message,
        messageStyle: { color: '#E67717' },
        // headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.cancelPopup,
            onClick: this.closePopup,
            outline: true,
          },
          {
            text: strings.confirm,
            onClick: onConfirm
              ? () => {
                onConfirm(data);
                this.setState({
                  popup: null,
                });
              }
              : this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  getData = async (paramsAPI, page, perPage) => {
    this.showSpinner();
    const { startDate, endDate, startTime, endTime, RFIDNumber } = this.state;

    if (!startTime || !endTime || !startDate || !endDate) {
      this.showErrorPopup(`Date and Time parameters cannot be empty!`);
      return;
    }

    let params = {
      startDate: `${moment(startDate).format('DD-MM-YYYY')} ${moment(
        startTime,
      ).format('HH:mm')}`,
      endDate: `${moment(endDate).format('DD-MM-YYYY')} ${moment(
        endTime,
      ).format('HH:mm')}`,
      pageNumber: page,
      pageSize: perPage,
      personRFID: RFIDNumber,
    };
    console.log('params...', params);
    API.fetchPersonActivityDetails(params)
      .then(res => {
        console.log('response:', res, perPage);
        paramsAPI.successCallback(
          res.data?.personHistory,
          res.data?.totalCount,
        );

        this.setState({
          personActivityList: res.data?.personHistory,
          popup: undefined,
          totalCount: res.data?.totalCount,
        });
      })
      .catch(err => {
        console.log('err', err);
        console.log(err);
        paramsAPI.successCallback([], 0);
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };

  onChangeHandler = (field, value) => {
    switch (field) {
      case 'RFIDNumber': {
        return this.setState({
          [field]: value,
        });
      }
      case 'startTime': {
        this.setState({
          startTime: value,
        });
        break;
      }
      case 'endTime': {
        this.setState({
          endTime: value,
        });
        break;
      }

      case 'date': {
        const { startDate, endDate, dates } = value;
        this.setState({
          startDate,
          endDate,
          dates,
        });
        break;
      }

      case 'gridAPI': {
        console.log('grid API', value);
        this.setState({ gridApi: value });
        this.onChangeHandler('updateTable');
        break;
      }
      case 'updateTable': {
        const { gridApi, selectedStatus } = this.state;
        const perPage = 100;
        if (gridApi) {
          const dataSource = {
            getRows: params => {
              const page = params.endRow / perPage;
              console.log(page, params, selectedStatus);
              this.getData(params, page - 1, perPage);
            },
          };
          gridApi.setDatasource(dataSource);
        }
        break;
      }
      default:
        return this.setState({
          [field]: {
            value,
            error: null,
          },
        });
    }
  };

  showTwoButtonsPopup = (errorMessage, onFirstClick, onSecondClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMessage,
        messageStyle: { color: '#E67717' },
        headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: `Cancel`,
            onClick: onFirstClick ? onFirstClick : this.closePopup,
            outline: true,
            style: { fontSize: '0.8rem' },
          },
          {
            text: `Recharge`,
            onClick: onSecondClick ? onSecondClick : this.closePopup,
            outline: true,
            style: {
              backgroundColor: '#0045e6',
              color: '#ffffff',
              fontSize: '0.8rem',
            },
          },
        ],
      },
    });
  };

  blackListPerson = data => {
    console.log(data);
    const { roleId } = this.state;
    if (!data?.remarks) {
      this.showErrorPopup('Please add the reason before blacklist the person');
      return;
    }
    if (!data?.id) {
      this.showErrorPopup(
        'There is an error while blacklisting the card, pleas try again after some time',
      );
      return;
    }

    if (roleId === 10) {
      this.showErrorPopup(
        'You do not have the permission to blacklisting the person',
      );
      return;
    }

    API.blackListPersonCard(data)
      .then(res => {
        console.log('res.data', res.data);
        this.showSuccessPopup(
          'You have blacklisted the person card successfully.',
          () => {
            this.getPersonData();
          },
        );
      })
      .catch(error => {
        console.log('error', error);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;

        this.setState({
          popup: null,
          personLatestActivity: null,
        });
        this.showErrorPopup(
          errorMsg ||
          'There was an error while blacklisting the person, please try again after some time.',
        );

        console.log(errorMsg);
      });
  };

  unBlackListPerson = data => {
    console.log(data);
    // if (!data?.remarks) {
    //   this.showErrorPopup('Please add the reason before blacklist the vehicle');
    //   return;
    // }
    const { roleId } = this.state;
    this.showSpinner();
    if (!data) {
      this.showErrorPopup(
        'There is an error while removing blacklist for the  person, pleas try again after some time',
      );
      return;
    }
    if (roleId === 10) {
      this.showErrorPopup(
        'You do not have the permission to removing the blacklist for the person',
      );
      return;
    }


    const inputObject = { id: data, remarks: '' };

    API.unBlackListPersonCard(inputObject)
      .then(res => {
        console.log('res.data', res.data);
        this.setState({
          popup: null,
        });
        this.showSuccessPopup(
          'You have removed the person card from blacklisting successfully.',
          () => {
            this.getPersonData();
          },
        );
      })
      .catch(error => {
        console.log('error', error);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;

        this.setState({
          popup: null,
          personLatestActivity: null,
        });
        this.showErrorPopup(
          errorMsg ||
          'There was an error while removing from the blacklist, please try again after some time.',
        );

        console.log(errorMsg);
      });
  };

  showErrorPopup = errorMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMessage,
        messageStyle: { color: '#E67717' },
        headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };
  showSuccessPopup = (message, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: message,
        headingImage: operatorImages.successIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  resetData = () => {
    this.setState(
      {
        startDate: moment().subtract(1, 'year'),
        startTime: moment().startOf('day'),
        endDate: moment().add(1, 'day'),
        endTime: moment().endOf('day'),
        dates: {
          start: moment().subtract(1, 'year').format('MM-DD-YYYY'),
          end: moment().add(1, 'day').format('MM-DD-YYYY'),
        },
      },
      this.onChangeHandler('updateTable'),
    );
  };

  resetState = () => {
    this.setState({
      popup: null,
    });
  };
  onClickHandler = (action, data) => {
    const { history, location } = this.props;
    switch (action) {
      case 'clear': {
        console.log('clicked on clear');
        this.reset();
        break;
      }
      case 'statusRoute': {
        //FIXME path
        history.push({
          pathname: '/u/view/' + data.route,
        });
        break;
      }
      case 'document-view': {
        console.log('in document view redirection case:', data);
        history.push({
          pathname: location.pathname + '/document-view',
          state: { background: location, url: data },
        });
        // this.getDocumentTempURL(data);

        break;
      }

      case 'apply': {
        this.onChangeHandler('updateTable');
        break;
      }
      case 'blackList': {
        this.blackListPerson(data);
        break;
      }
      case 'unBlackList': {
        this.unBlackListPerson(data);
        break;
      }

      case 'clearFilters': {
        this.resetData();
        break;
      }

      default: {
        console.warn('no action taken');
      }
    }
  };

  reset = () => {
    this.resetState();
  };
  showSpinner = () => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });
  };

  closePopup = () => {
    this.setState({
      popup: null,
    });
  };

  getProps = () => {
    const { reduxProps } = this.props;
    const { permits } = reduxProps;
    const { passDate, availableCredits, serverTime } = this.state;
    return {
      stateData: this.state,
      onChangeHandler: this.onChangeHandler,
      onClick: this.onClickHandler,
      passDate,
      serverTime,
      onSubmit: this.getPersonData,
    };
  };

  render() {
    const viewProps = this.getProps();
    const { popup } = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer containerStyle={styles.popupContainerStyle}>
            {' '}
            {this.getPopupContent()}{' '}
          </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}
// export default withRouter(PersonView);
const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PersonView),
);
